// @flow
import { getWhiteLabelSiteName, getWhiteLabelSiteUrl } from '../../../redux/modules/whiteLabel';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import WhiteLabelCrown from './WhiteLabelCrown';

const mapStateToProps = state => {
    return {
        siteName: getWhiteLabelSiteName(state),
        siteUrl: getWhiteLabelSiteUrl(state),
    };
};

type Props = {
    siteName: string,
    siteUrl: string,
};

class WhiteLabelCrownContainer extends PureComponent<Props> {
    render() {
        const { siteName, siteUrl } = this.props;

        return <WhiteLabelCrown siteName={siteName} siteUrl={siteUrl} />;
    }
}

export default connect(mapStateToProps)(WhiteLabelCrownContainer);
